import { DataSource } from 'hooks/useHttpClient';
import {
    LoginResolver,
    ResolveHardwareList,
    ResolveMyself,
    ResolveNotifications,
    ResolvePermissions,
    ValidateInvitationResolver
} from '../Common';
import { CompanyListResolver, CompanyMemberListResolver, CompanyNameAvailableResolver, CreateOrSingleCompanyResolver } from '../Company';
import { CommentListResolver } from '../Comment';
import { DocumentListResolver } from '../Document';
import { CandidateApplicationResolver, CandidateListResolver, CandidateSingeResolver, CandidateSingleDeviceResolver } from '../Candidate';
import {
    JobAsOptionsList,
    JobListResolver,
    JobPaginatedListResolver,
    JobSingleResolver,
    NastyPipelineResolverToApplications
} from '../Job';
import { HttpClientResponse } from 'hooks/HttpClient';
import { GetCompanyOptionsResolver, GetCompanyStatusResolver, GetFullTeamMemberResolver, GetTeamByJobResolver } from '../Teams';
import { FastTaskListResolver, NastyTaskListResolver, TaskSingleResolver } from '../Task';
import { NastyQuestionnaireResolver, OnboardingListResolver, OnboardingSingleResolver, OnboardingTaskListResolver } from '../Onboarding';
import { MappedEntityType } from '..';
import { FastMemberOptionListResolver } from '../Members';
import { LegacyCountryResolver } from '../Legacy';
import { SingleFullUserResolver, UserListResolver } from '../Users';

export default function resolveData<T>(
    dataSource: DataSource,
    mappedType: MappedEntityType,
    apiResponse: any,
    fullResponse: HttpClientResponse<T>
): T | null {
    switch (mappedType) {
        case MappedEntityType.LoginResponse:
            return LoginResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.ValidateInvite:
            return ValidateInvitationResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetCompany:
        case MappedEntityType.CreateCompany:
            return CreateOrSingleCompanyResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CompanyNameAvailable:
            return CompanyNameAvailableResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CompanyList:
            return CompanyListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CompanyCommentList:
            return CommentListResolver(dataSource, apiResponse, true) as T | null;

        case MappedEntityType.CompanyMembersList:
            return CompanyMemberListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CompanyDocumentsList:
        case MappedEntityType.GetOnboardingDocuments:
        case MappedEntityType.GetMemberDocuments:
            return DocumentListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CandidateList:
            return CandidateListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetCandidate:
            return CandidateSingeResolver(dataSource, apiResponse.data, true) as T | null;

        case MappedEntityType.GenericGetComments:
            return CommentListResolver(dataSource, apiResponse.data, true) as T | null;

        case MappedEntityType.JobList:
            return JobPaginatedListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetJob:
            return JobSingleResolver(dataSource, apiResponse.data, true) as T | null;

        case MappedEntityType.JobPipeline:
            return NastyPipelineResolverToApplications(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetApplication:
            return CandidateApplicationResolver(dataSource, apiResponse.data, true) as T | null;

        case MappedEntityType.GetDocument:
            return fullResponse.blob as T | null;

        case MappedEntityType.GetCompanyOptions:
            return GetCompanyOptionsResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetCompanyOptionsStatus:
            return GetCompanyStatusResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetTeamByCompany:
            return GetTeamByJobResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetTasks:
            return NastyTaskListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetFastTasks:
            return FastTaskListResolver(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.GetSingleTask:
            return TaskSingleResolver(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.OnboardingList:
            return OnboardingListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetOnboarding:
            return OnboardingSingleResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetOnboardingTasks:
            return OnboardingTaskListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetMyself:
            return ResolveMyself(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.GetOnboardingQuestionnaire:
            return NastyQuestionnaireResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetPossibleMembers:
            return FastMemberOptionListResolver(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.LegacyCountry:
            return LegacyCountryResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.CompanyJobList:
            return JobListResolver(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.HardwareList:
            return ResolveHardwareList(dataSource, apiResponse) as T | null;

        case MappedEntityType.JobsAsOptions:
            return JobAsOptionsList(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetPermissions:
            return ResolvePermissions(dataSource, apiResponse) as T | null;

        case MappedEntityType.NotificationList:
            return ResolveNotifications(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.GetUser:
        case MappedEntityType.GetFullMyself:
            return SingleFullUserResolver(dataSource, apiResponse.data) as T | null;

        case MappedEntityType.UserList:
            return UserListResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetFullTeamMember:
            return GetFullTeamMemberResolver(dataSource, apiResponse) as T | null;

        case MappedEntityType.GetCandidateDevice:
            return CandidateSingleDeviceResolver(dataSource, apiResponse.device) as T | null;

        default:
            return apiResponse as T | null;
    }
}
